module.exports = __webpack_public_path__ + "img/geod_12.777342ac.jpg";